import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

import { SnSessionService } from '../../services';
import { TranslationService } from '@lib/translation';

@Component({
  templateUrl: './single-sign-on.view.html',
  styleUrls: ['./single-sign-on.view.scss'],
})
export class SingleSignOnView implements OnInit, OnDestroy {
  public options: any[];
  public isLoading = true;
  public imageUrl: SafeUrl;
  public translationsLoaded = false;
  private readonly _destroy$ = new Subject();

  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _router: Router,
    private readonly _sessionService: SnSessionService,
    private readonly _sanitizer: DomSanitizer,
    private readonly _translationService: TranslationService,
    private readonly _changeDetectorRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this._translationService.translationReady$().pipe(
      takeUntil(this._destroy$)
    ).subscribe(() => {
      this.translationsLoaded = true;
      this._changeDetectorRef.detectChanges();
      
      this._route.params.pipe(takeUntil(this._destroy$)).subscribe((data) => {
        const test = !!this._route.snapshot.queryParams['test'];
        const prefix = data['prefix'];
        this._getProviders(prefix, test);
      });
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public goToProvider(provider: any): void {
    window.location = provider.redirectUrl;
  }

  public sanitizeUrl(url: string): SafeUrl {
    return this._sanitizer.bypassSecurityTrustUrl(url);
  }

  private _getProviders(prefix: string, test: boolean): void {
    this._sessionService
      .providers(prefix, test)
      .pipe(takeUntil(this._destroy$))
      .subscribe((response) => {
        this.isLoading = false;
        if (response.count === 0) {
          this._router.navigateByUrl('/auth/sign-in');
          return;
        }
        this.options = response.results;
      });
  }
}
